import { button } from '@material-tailwind/react'
import React from 'react'

const Infocards = ({ Title, value, button }) => {
    return (
        <div>
            <div className=' rounded-lg text-white h-18 bg-[linear-gradient(0deg,#055096_0%,#4EB0E2_100%)] p-3 '>
                <div>
                    {Title}

                </div>
                <div className='font-semibold'>
                    {value}
                    {button}
                </div>

            </div>
        </div>
    )
}

export default Infocards
